import { lazy } from 'react';

export const PlayerGeoLocationStatusForm = lazy(
  () => import('./PlayerGeoLocationStatusForm'),
);
